import { useEffect, useRef, useState } from 'react';
import { routeGeometry } from './eta';

// Road-following polyline between two {lat,lng} points — the Google Maps
// style routed line. Returns the OSRM driving geometry when it resolves and
// the straight [from, to] segment while loading or when routing fails, so
// the map always has something to draw.
//
// Endpoint keys are rounded to ~100m so GPS jitter doesn't refire the fetch.
export default function useRoadRoute(from, to) {
  const [road, setRoad] = useState(null);
  const keyRef = useRef('');
  const key =
    from && to
      ? `${from.lat.toFixed(3)},${from.lng.toFixed(3)}>${to.lat.toFixed(3)},${to.lng.toFixed(3)}`
      : '';

  useEffect(() => {
    if (key === keyRef.current) return;
    keyRef.current = key;
    if (!from || !to) {
      setRoad(null);
      return;
    }
    let alive = true;
    routeGeometry(from, to).then((geom) => {
      if (alive) setRoad(geom && geom.length > 1 ? geom : [from, to]);
    });
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return from && to ? road || [from, to] : null;
}
